import { render } from "./DSAReportLandingPage.vue?vue&type=template&id=07c4f615"
import script from "./DSAReportLandingPage.vue?vue&type=script&lang=js"
export * from "./DSAReportLandingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__